<div [formGroup]="form"
     class="flex-col gap-16 form">
    <div class="flex-col gap-8">
        <label>{{ 'COMMON.NAME'|translate }} <span class="required">*</span></label>
        <input class="ui-input ui-input-40"
               formControlName="name">
    </div>

    <div class="flex-col gap-8">
        <label>{{ 'FLOW_CHART.NODES.SEND_SMS.LABELS.SELECT_ORG_USERS'|translate }}</label>

        <org-users-select formControlName="orgUsersIds"
                          [warningToolttipAttr]="'email'"
                          [warningTooltip]="'FLOW_CHART.NODES.SEND_SMS.NO_EMAIL_TOOLTIP'">
        </org-users-select>
    </div>

    <div class="flex-col gap-8">
        <label>{{ 'FLOW_CHART.NODES.SEND_SMS.LABELS.SELECT_CONTACTS'|translate }}</label>

        <contacts-select formControlName="contactsIds"
                         [dialogComponent]="createEmailContactDialogComponent"
                         [warningToolttipAttr]="'emails'"
                         [warningTooltip]="'FLOW_CHART.NODES.SEND_SMS.NO_EMAIL_TOOLTIP'"
                         [createWithSearchValue]="true">
        </contacts-select>
    </div>

    <div class="flex-col gap-8">
        <label>{{ 'FLOW_CHART.NODES.SEND_EMAIL.SUBJECT'|translate }} <span class="required">*</span></label>
        <input class="ui-input ui-input-40"
               formControlName="subject">
    </div>

    <div class="flex-col gap-8">
        <label>{{ 'FLOW_CHART.NODES.SEND_EMAIL.NAME'|translate }}</label>

        <ui-text-area-variables formControlName="body"
                                [options]="selectVariablesAutoComplete">
        </ui-text-area-variables>
    </div>
</div>